import { defineStore } from 'pinia';
import { setUserInfo, clearUserInfo, getUserInfo } from '@/utils/auth';
import { removeRouteListener } from '@/utils/route-listener';
import { UserState } from './types';
// import useAppStore from '../app';

const userInfo = getUserInfo();

const useUserStore = defineStore('user', {
  state: (): UserState => ({
    // 用户登录返回的信息
    userLoginInfo: userInfo || {},
    // currentUser.ac 的信息
    userInfo: undefined,
    permissions: [],
    permissionRemarkMap: {},
    companyInfo: undefined,
    companyConfig: [],
    userConfig: [],
    // 用户token
    userToken: '',
    role: '',
    // 用户系统配置
    sysConfigList: [],
    // 用户系统配置: configKey-configValue
    sysConfigMap: {},
    enablePaymentServiceMap: {},
    // 用户配置
    userConfigList: [],
    // 用户配置 configKey-configValue
    userConfigMap: {},
    // 用户配置自定义工序节点列--生产明细
    userProcessColumn: [],
  }),

  getters: {
    // 是否展示生产批次
    hasProduceBatch(state: UserState) {
      const configList: any = state.sysConfigList;
      if (!Array.isArray(configList)) {
        return false;
      }
      return !!configList.find(
        (item: any) => item.configKey === 'produceBatchSnGenerate'
      )?.enable;
    },
    // 生产批次生产规则是否是按照货号
    isGoodsSnProBatchType(state: UserState) {
      const configList: any = state.sysConfigList;
      if (!Array.isArray(configList)) {
        return false;
      }
      const configData =
        configList.find(
          (item: any) => item.configKey === 'produceBatchSnGenerate'
        )?.configValue || '';
      const type = configData ? JSON.parse(configData)?.type || 2 : 2;
      return type === 3;
    },
    getUserInfo(state: UserState): UserState {
      return { ...state };
    },

    // 物料小数位
    materialDecimal(state: UserState): number {
      let materialDecimalVal = 2;
      state.sysConfigList.forEach((item: Record<string, any>) => {
        if (item.configKey === 'materialDecimal' && item.configValue) {
          materialDecimalVal = Number(item.configValue);
        }
      });
      return materialDecimalVal;
    },
    // 系统控制的物料多规格开关
    isOpenMaterialMulSpec(state: UserState): number {
      let isOpenMaterialMulSpecVal = 0;
      state.sysConfigList.forEach((item: Record<string, any>) => {
        if (item.configKey === 'isOpenMaterialMulSpec' && item.configValue) {
          isOpenMaterialMulSpecVal = Number(item.configValue);
        }
      });
      return isOpenMaterialMulSpecVal;
    },
    // 系统控制的【入库需要复核】开关，默认关
    isOpenRecheckStoreIn(state: UserState): number {
      const recheckStoreInConfig = state.sysConfigList.find(
        (item: Recordable) => {
          return item.configKey === 'recheckStoreIn';
        }
      );
      if (recheckStoreInConfig) {
        return Number((recheckStoreInConfig as Recordable).configValue);
      }
      return 0;
    },
    // 系统控制的【入库需要复核】开关，默认关
    isOpenMaterialIssue(state: UserState): number {
      const isOpenMaterialIssueConfig = state.sysConfigList.find(
        (item: Recordable) => {
          return item.configKey === 'isOpenMaterialIssue';
        }
      );
      if (isOpenMaterialIssueConfig) {
        return Number((isOpenMaterialIssueConfig as Recordable).configValue);
      }
      return 0;
    },
    isOpenProdStoreIn(state: UserState): number {
      const prodStoreInConfig = state.sysConfigList.find((item: Recordable) => {
        return item.configKey === 'excessLimitInboundNumber';
      });
      if (prodStoreInConfig) {
        return Number((prodStoreInConfig as Recordable).configValue);
      }
      return 0;
    },
  },

  actions: {
    setUserProcessColumn(processColumn: any[]) {
      this.userProcessColumn = processColumn;
    },
    setUserConfigMap(configList: Array<any> = []) {
      const userConfigMap: Recordable = {};
      if (Array.isArray(configList)) {
        configList.forEach((config: any) => {
          const { configKey, configValue } = config;
          userConfigMap[configKey] = configValue;
        });
      }
      this.userConfigMap = userConfigMap;
    },
    setSysConfigMap(configList: Array<any> = []) {
      const sysConfigMap: Recordable = {};
      if (Array.isArray(configList)) {
        configList.forEach((config: any) => {
          const { configKey, configValue } = config;
          sysConfigMap[configKey] = configValue;
        });
      }
      this.sysConfigMap = sysConfigMap;
    },
    switchRoles() {
      return new Promise((resolve) => {
        resolve({});
      });
    },
    // Set user's information
    setInfo(partial: Partial<UserState>) {
      this.$patch(partial);
      if (partial.sysConfigList) this.setSysConfigMap(partial.sysConfigList);
      if (partial.userConfigList) this.setUserConfigMap(partial.userConfigList);
    },
    // Reset user's information
    resetInfo() {
      this.$reset();
    },

    // Get user's information
    async info() {
      // const res = await getUserInfo();
      // this.setInfo(res.data);
    },

    // Login
    async loginCallback(res: any) {
      try {
        this.userLoginInfo = res.data;
        setUserInfo(res.data);
      } catch (err) {
        clearUserInfo();
        throw err;
      }
    },
    logoutCallBack() {
      // const appStore = useAppStore();
      // this.resetInfo();
      clearUserInfo();
      removeRouteListener();
      // appStore.clearServerMenu();
    },
    // Logout
    async logout() {
      // try {
      //   await userLogout();
      // } finally {
      //   this.logoutCallBack();
      // }
      this.logoutCallBack();
      window.location.reload(); // 刷新当前页面
    },
  },
});

export default useUserStore;
